import { MapPin, Phone, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function ContactInformation() {
  return <section id="contact-information" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Kontakt informacije
          </h2>
          <p className="text-muted-foreground text-lg">Stojimo vam na raspolaganju za sve upite. <br />Kontaktirajte nas putem telefona, emaila ili Whats Up-a</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {}
          <Card className="border-border shadow-sm hover:shadow-md transition-shadow pt-6 h-full">
            <CardContent className="flex flex-col items-center text-center px-6 pb-6 h-full">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 text-primary shrink-0">
                <MapPin className="w-7 h-7" />
              </div>
              <h3 className="font-default text-xl font-semibold mb-4 text-foreground">Adresa</h3>
              <div className="mt-auto flex flex-col items-center justify-center">
                <p className="font-semibold text-foreground text-lg mb-1">Tech Start</p>
                <p className="text-muted-foreground">Augusta Cesarca 6</p>
                <p className="text-muted-foreground">Velika Gorica</p>
              </div>
            </CardContent>
          </Card>

          {}
          <Card className="border-border shadow-sm hover:shadow-md transition-shadow pt-6 h-full">
            <CardContent className="flex flex-col items-center text-center px-6 pb-6 h-full">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 text-primary shrink-0">
                <Phone className="w-7 h-7" />
              </div>
              <h3 className="font-default text-xl font-semibold mb-4 text-foreground">Telefon</h3>
              <div className="mt-auto flex flex-col items-center justify-center h-[76px]">
                <Link to="tel:+385916509999" className="text-foreground hover:text-primary transition-colors text-lg font-medium">
                  +385 91 650 9999
                </Link>
              </div>
            </CardContent>
          </Card>

          {}
          <Card className="border-border shadow-sm hover:shadow-md transition-shadow pt-6 h-full">
            <CardContent className="flex flex-col items-center text-center px-6 pb-6 h-full">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 text-primary shrink-0">
                <Mail className="w-7 h-7" />
              </div>
              <h3 className="font-default text-xl font-semibold mb-4 text-foreground">Email</h3>
              <div className="mt-auto flex flex-col items-center justify-center h-[76px]">
                <div className="text-foreground text-lg font-medium flex items-center gap-0.5 flex-wrap justify-center">
                  <span>mario.techstart</span>
                  <span className="text-primary">@</span>
                  <span>gmail.com</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}